import { useHtmlId } from '@ipfabric/frontend-shared-assets/utils/react/HtmlId';
import { FormField } from '../FormField/FormField';
import type { FormFieldBaseProps } from '../FormField/FormField.types';
import { MultiSelect } from '../MultiSelect/MultiSelect';
import type { MultiSelectProps } from '../MultiSelect/MultiSelect.types';

export type MultiSelectFieldProps<TValue extends string> =
  MultiSelectProps<TValue> & FormFieldBaseProps;

export const MultiSelectField = <TValue extends string>({
  className,
  error,
  name,
  ...props
}: MultiSelectFieldProps<TValue>) => {
  const multiSelectInputId = useHtmlId('multiSelectInput');
  return (
    <FormField
      className={className}
      htmlFor={multiSelectInputId}
      error={error}
      {...props}
    >
      <MultiSelect
        hasError={props.hasError || error !== undefined}
        name={name}
        inputId={multiSelectInputId}
        {...props}
      />
    </FormField>
  );
};
